module.exports = __webpack_public_path__ + "img/squirrel_setup2.0f2ae71e.png";